import { render, staticRenderFns } from "./LikertQuestionInput.vue?vue&type=template&id=de8e217c&scoped=true&"
import script from "./LikertQuestionInput.vue?vue&type=script&lang=js&"
export * from "./LikertQuestionInput.vue?vue&type=script&lang=js&"
import style0 from "./LikertQuestionInput.vue?vue&type=style&index=0&id=de8e217c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de8e217c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
